var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTronIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3206_302720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0422 31.7696C24.8364 31.7696 31.9654 24.6972 31.9654 15.9728C31.9654 7.24847 24.8364 0.175995 16.0422 0.175995C7.24808 0.175995 0.119019 7.24847 0.119019 15.9728C0.119019 24.6972 7.24808 31.7696 16.0422 31.7696Z",
    fill: "#EB0029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2914 9.64051L7 7L14.52 26L25 13.1819L21.2914 9.64051ZM21.0609 10.8052L23.2473 12.8908L17.2668 13.9783L21.0609 10.8052ZM15.969 13.7593L9.66616 8.51189L19.9676 10.4145L15.969 13.7593ZM15.5203 14.6888L14.4928 23.2176L8.95097 9.21868L15.5203 14.6888ZM16.471 15.1405L23.0924 13.9373L15.498 23.2276L16.471 15.1405Z",
    fill: "#FEE2E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3206_302720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronIconRound);
export default __webpack_public_path__ + "static/media/tronIconRound.a344b1cd01ef77c945cb51d51a3f9d86.svg";
export { ForwardRef as ReactComponent };